import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ViewIcon from "@material-ui/icons/Visibility";
import FolderIcon from "@material-ui/icons/Folder";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CustomToolbar from "../common/AddButton";
import api from "../common/api";
import { Col, Container, Row } from "shards-react";

class VehiclesAttachments extends React.Component {
  constructor() {
    super();

    this.state = {
      data: [],
      isLoaded: false,
      vehicles: []
    };
  }

  async componentDidMount() {
    await this.getVehicleAttachments();
  }

  async getVehicleAttachments() {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.vehicles().attachments(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        console.log("!", res.data);
        this.setState({ data: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "4px 12px 4px 12px",
            fontSize: "0.73rem"
          }
        }
      }
    });

  getColumns = () => {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: "plate",
        label: "Patente",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "description",
        label: "Descripcion",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "state",
        label: "Estado Vehiculo",
        options: {
          filter: true,
          filterType: "dropdown",
          sort: true,
          display: false
        }
      },
      {
        name: "client",
        label: "Client",
        options: {
          filter: true,
          filterType: "dropdown",
          sort: true
        }
      },
      {
        name: "firstname",
        label: "Nombre conductor",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "lastname",
        label: "Apellido conductor",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "hansa_code",
        label: "Codigo conductor",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "email",
        label: "Email conductor",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "attachment",
        label: "Adjunto",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      }
    ];
    return columns;
  };

  render() {
    const options = {
      download: true,
      customToolbar: () => {
        return (
          <React.Fragment>
            <CustomToolbar url="new" />
          </React.Fragment>
        );
      },
      print: false,
      responsive: "stacked",
      selectableRowsOnClick: true,
      rowsPerPage: 10,
      selectableRows: false,
      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };

    return (
      <React.Fragment>
        <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
                <MuiThemeProvider theme={this.getMuiTheme()}>
                  <MUIDataTable
                    title="Lista de adjuntos app mobile"
                    data={Object.values(this.state.data)}
                    columns={this.getColumns()}
                    options={options}
                  />
                </MuiThemeProvider>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default VehiclesAttachments;
